/* Scoped to the approved adult thobe range. Native form/variant/cart components remain authoritative. */
const scopeSelector = '[data-ii-fashion-main]';
class IIThobeGallery extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.scope = this.closest(scopeSelector);
    this.panels = [...this.querySelectorAll('[data-ii-colour]')];
    this.addEventListener('click', event => {
      const thumb = event.target.closest('[data-ii-thumb]');
      if (thumb) this.selectPhoto(thumb.closest('[data-ii-colour]'), Number(thumb.dataset.iiThumb));
      if (event.target.closest('[data-ii-enlarge]')) this.openZoom();
      if (event.target.closest('[data-ii-close]')) this.querySelector('dialog').close();
    }, {signal:this.controller.signal});
    this.addEventListener('keydown', event => {
      const thumb=event.target.closest('[data-ii-thumb]');
      if (!thumb || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      const panel=thumb.closest('[data-ii-colour]'),buttons=[...panel.querySelectorAll('[data-ii-thumb]')];
      let index=buttons.indexOf(thumb);
      if(event.key==='Home')index=0;else if(event.key==='End')index=buttons.length-1;else index=(index+(event.key==='ArrowRight'?1:-1)+buttons.length)%buttons.length;
      event.preventDefault();buttons[index].focus();this.selectPhoto(panel,index);
    }, {signal:this.controller.signal});
    this.scope.addEventListener('change',event=>{
      if(event.target.closest('block-variant-picker'))this.syncColour();
    },{signal:this.controller.signal});
    const picker=this.scope.querySelector('block-variant-picker');
    if(picker)document.addEventListener('variant:change:'+picker.dataset.sectionId+':'+picker.dataset.productId,()=>this.syncColour(),{signal:this.controller.signal});
    this.syncColour();
  }
  disconnectedCallback(){this.controller?.abort();this.controller=null;}
  syncColour(){
    const checked=this.scope.querySelector('block-variant-picker input[name="Color"]:checked');
    const colour=checked?.value || this.dataset.initialColour;
    const panel=this.panels.find(p=>p.dataset.iiColour===colour);
    if(!panel)return;
    for(const other of this.panels)other.hidden=other!==panel;
    this.dataset.activeColour=colour;
    this.selectPhoto(panel,0);
    this.querySelector('[data-ii-gallery-label]').textContent=colour;
  }
  selectPhoto(panel,index){
    if(!panel)return;
    const slides=[...panel.querySelectorAll('[data-ii-slide]')],buttons=[...panel.querySelectorAll('[data-ii-thumb]')];
    if(!slides[index]){this.querySelector('[data-ii-gallery-status]').textContent='';return;}
    slides.forEach((slide,i)=>{slide.hidden=i!==index;});
    buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
    const image=slides[index].querySelector('img');image.loading='eager';
    this.querySelector('[data-ii-gallery-status]').textContent=slides[index].dataset.caption;
  }
  openZoom(){
    const panel=this.panels.find(p=>!p.hidden),slide=panel?.querySelector('[data-ii-slide]:not([hidden])'),image=slide?.querySelector('img'),dialog=this.querySelector('dialog');
    if(!image||!dialog)return;
    const zoom=dialog.querySelector('img');zoom.src=image.dataset.full;zoom.alt=image.alt;dialog.showModal();
  }
}
if(!customElements.get('ii-thobe-gallery'))customElements.define('ii-thobe-gallery',IIThobeGallery);
class IIThobePrice extends HTMLElement{
  connectedCallback(){
    this.controller=new AbortController();
    document.addEventListener('variant:change:'+this.dataset.sectionId+':'+this.dataset.productId,event=>{
      const {html,variant,loading}=event.detail||{};
      if(loading||!html||!variant)return;
      const source=html.querySelector('ii-thobe-price[data-section-id="'+this.dataset.sectionId+'"][data-product-id="'+this.dataset.productId+'"]');
      const stack=source?.querySelector('layout-stack'),destination=this.querySelector('layout-stack');
      if(stack&&destination)destination.replaceWith(stack.cloneNode(true));
      if(source)for(const key of ['data-on-sale','data-unit-price','data-sold-out'])this.toggleAttribute(key,source.hasAttribute(key));
    },{signal:this.controller.signal});
  }
  disconnectedCallback(){this.controller?.abort();}
}
if(!customElements.get('ii-thobe-price'))customElements.define('ii-thobe-price',IIThobePrice);
customElements.whenDefined('block-variant-picker').then(()=>{
  for(const scope of document.querySelectorAll(scopeSelector)){
    const picker=scope.querySelector('block-variant-picker');
    if(!picker||picker.dataset.iiPatched)return;
    picker.dataset.iiPatched='true';
    /* Preserve the alternate preview when the native component refreshes a section. */
    picker.updateURL=function(){
      if(!this.currentVariant||!('updateUrl' in this.dataset))return;
      const url=new URL(this.dataset.url,location.origin);
      const current=new URL(location.href);
      for(const key of ['preview_theme_id','view'])if(current.searchParams.has(key))url.searchParams.set(key,current.searchParams.get(key));
      url.searchParams.set('variant',this.currentVariant.id);
      history.replaceState({},'',url.pathname+url.search);
    };
    picker.productInfo.clear();
    picker.getProductInfo=function(){
      const id=this.currentVariant.id;
      if(!this.productInfo.has(id)){
        const url=new URL(this.dataset.url,location.origin);
        url.searchParams.set('variant',id);url.searchParams.set('section_id',this.dataset.sectionId);
        const current=new URL(location.href);for(const key of ['preview_theme_id','view'])if(current.searchParams.has(key))url.searchParams.set(key,current.searchParams.get(key));
        this.productInfo.set(id,fetch(url).then(response=>{if(!response.ok)throw new Error('Product information unavailable');return response.text();}).then(text=>new DOMParser().parseFromString(text,'text/html')));
      }
      return this.productInfo.get(id);
    };
    const guide=scope.querySelector('[data-ii-measure]');
    const updateGuide=()=>{
      const size=scope.querySelector('block-variant-picker input[name="Size"]:checked')?.value||'54';
      const length=Number.parseInt(size,10);if(!Number.isFinite(length))return;
      guide?.querySelectorAll('[data-ii-length-in]').forEach(e=>{e.textContent=String(length);});
      guide?.querySelectorAll('[data-ii-length-cm]').forEach(e=>{e.textContent=(length*2.54).toFixed(1);});
      guide?.querySelectorAll('[data-ii-selected-size]').forEach(e=>{e.textContent=size;});
    };
    scope.addEventListener('change',updateGuide);updateGuide();
  }
});
